module.exports = __webpack_public_path__ + "static/media/ansonia.e20d6422.jpg";